import css from 'styled-jsx/css';

const styles = css.global`/*#region Overrides */

.sn-datepicker-inline {
  position: relative;
  display: block;
}

.sn-datepicker .placeholder {
  color: #444444;
  font-family: 'SantanderText';
  font-weight: 400;
  font-size: 18px;
  line-height: 1;
}

.sn-datepicker-inline>div {
  display: flex;
  width: 100%;
  height: auto;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  box-sizing: border-box;
}

.sn-datepicker-inline .react-datepicker {
  border: none;
  box-shadow: none;
  outline: none;
  background: transparent;
  font-family: 'SantanderText';
  display: flex;
  align-items: center;
  justify-content: center;
}

.sn-datepicker-inline .react-datepicker .react-datepicker__month-container {
  width: 100%;
  max-width: 272px;
}

.sn-datepicker-inline .react-datepicker .react-datepicker__header {
  background: transparent;
  border-bottom-color: #ccc;
  padding: 0;
}

.sn-datepicker-inline .react-datepicker .react-datepicker__day-names {
  box-sizing: border-box;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 16px 0;
}

.sn-datepicker-inline .react-datepicker .react-datepicker__day-name {
  margin: 0;
  padding: 0;
  height: auto;
  width: auto;
  flex: 1;

  color: #222;
  text-align: center;
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
}

.sn-datepicker-inline .react-datepicker .react-datepicker__month {
  margin: 16px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  box-sizing: border-box;
}

.sn-datepicker-inline .react-datepicker .react-datepicker__week {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 32px;
}

.sn-datepicker-inline .react-datepicker .react-datepicker__day {
  margin: 0;
  padding: 0;
  flex: 1;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  color: #444;

  font-family: 'SantanderMicroText';
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
}

.sn-datepicker-inline .react-datepicker .react-datepicker__day--disabled {
  color: #ccc;
}

.sn-datepicker-inline .react-datepicker .react-datepicker__day--selected {
  position: relative;
  background: #c00;
  color: #fff;
}

/* .sn-datepicker-inline .react-datepicker .react-datepicker__day--selected::after {
  content: '';
  display: block;
  position: absolute;
  border: 1px solid #ccc;
  border-radius: 50%;
  background: none;
  height: 32px;
  width: 32px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
} */

@media (min-width: 992px) {
  .sn-datepicker-inline .react-datepicker .react-datepicker__month-container {
    max-width: 100%;
  }
}

/*#endregion Overrides */

/* #region CustomDateContainer */
.sn-datepicker-inline .custom-date-container {
  display: block;
  border-radius: 4px;
  border: 1px solid #ccc;
  background: #fff;
  box-shadow: 0 2px 16px -2px rgba(34, 34, 34, 0.12);
  box-sizing: border-box;
  padding: 24px 16px;
  max-width: 100%;
}

/* #endregion CustomDateContainer */

/* #region CustomDateHeader */

.sn-datepicker-inline .react-datepicker .custom-date-header {
  display: flex;
  max-width: 100%;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.sn-datepicker-inline .react-datepicker .custom-date-header .date-header-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  box-sizing: border-box;
  width: 100%;
  padding: 0;
  margin: 0;
}

.sn-datepicker-inline .react-datepicker .custom-date-header .date-select-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 50%;
  max-width: 121px;
}

.sn-datepicker-inline .react-datepicker .custom-date-header .select-btn {
  color: black;
  box-sizing: border-box;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
}

.sn-datepicker-inline .react-datepicker .custom-date-header .select-btn.disabled {
  opacity: 0.5;
}

.sn-datepicker-inline .react-datepicker .custom-date-header .date-select {
  -moz-appearance: none;
  /* Firefox */
  -webkit-appearance: none;
  /* Safari and Chrome */
  appearance: none;

  border: none;
  outline: none;

  color: #c00;
  text-align: center;

  font-family: 'SantanderText';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  /* 155.556% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.sn-datepicker-inline .react-datepicker .custom-date-header .date-select option {
  font: inherit;
  color: #222;
  padding: 0 8px;
}

.sn-datepicker-inline .react-datepicker .custom-date-header .date-arrow {
  pointer-events: none;
}

/* #endregion CustomDateHeader */`;

export default styles;